import { Environments } from '@mira-avant/mtlibs';

export const environment = {
	production: false,
	stage: Environments.DEVELOPMENT,
	apiUrl: 'https://api.dev.mira-learn.com/api',
	tld: 'mira-learn.com',
	uploaderApiUrl: 'https://uploader.dev.mira-learn.com/api',
	coachApiRoot: 'https://coach-api.dev.mira-learn.com',
	coachFrontendRoot: 'https://coach.dev.mira-learn.com',
	coachAudioRoot: 'https://cdn.dev.mira-learn.com',
	defaultDevSubDomains: 'journey.dev',
	proxyDomain: 'journey.dev.mira-learn.com',
	sentryDsn:
		'https://6027b16b1c9d31c5ec4ad3d084c693dc@o4507091332104192.ingest.us.sentry.io/4508916165246976',
	clever: {
		response_type: 'code',
		redirect_uri: 'https://api.dev.mira-learn.com/api/clever/callback',
		client_id: '1759b137049cd7702506',
		scope: 'read:district_admins, read:districts, read:school_admins, read:schools, read:sections, read:student_contacts, read:students, read:teachers, read:user_id',
		//district_id: '...',
	},
};
